/* unplugin-vue-components disabled */import script from "./EditProfileDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfileDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditProfileDialog.vue?vue&type=style&index=0&id=978ea314&lang=scss"
import "./EditProfileDialog.vue?vue&type=style&index=1&id=978ea314&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-978ea314"]])

export default __exports__